import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { COLORS, FONTS } from "@/lib/constants";
import { api } from "@/lib/api";

export default function BillingSuccess() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState({ status: "pending", plan: "" });
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    const poll = async () => {
      try {
        const r = await api.billingStatus(sessionId);
        if (cancelled) return;
        setStatus(r);
        if (r.payment_status !== "paid" && tries < 12) {
          setTimeout(() => setTries((t) => t + 1), 2000);
        }
      } catch (e) {
        console.warn("billing status", e);
      }
    };
    poll();
    return () => {
      cancelled = true;
    };
  }, [sessionId, tries]);

  return (
    <div
      data-testid="billing-success-screen"
      style={{
        minHeight: "100vh",
        background: COLORS.bg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
    >
      <div
        style={{
          maxWidth: 480,
          background: COLORS.surface,
          border: `1px solid rgba(var(--role-green-rgb),0.33)`,
          borderRadius: 16,
          padding: 32,
          textAlign: "center",
        }}
      >
        <div style={{ color: COLORS.symbiosis, fontFamily: FONTS.heading, fontSize: 28, marginBottom: 12 }}>
          {status.payment_status === "paid" ? "Welcome to YUO " + (status.plan || "").toUpperCase() : "Confirming payment…"}
        </div>
        <div style={{ color: COLORS.textSecondary, fontFamily: FONTS.body, fontSize: 15, marginBottom: 24 }}>
          {status.payment_status === "paid"
            ? "Your plan is active. Everything you unlocked is now available."
            : "This can take a moment. Please stay on this page."}
        </div>
        <button
          onClick={() => navigate("/mirror")}
          data-testid="billing-continue-btn"
          style={{
            background: COLORS.symbiosis,
            color: "#000",
            borderRadius: 999,
            padding: "12px 22px",
            fontFamily: FONTS.body,
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          Continue
        </button>
      </div>
    </div>
  );
}
